"use strict";

exports.__esModule = true;
exports["default"] = FooterLineZigzag;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function FooterLineZigzag(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 97.5 12.2",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 6.2h53.9m-.2 0h3.5l2.7-4.3 5.2 8.4 5.2-8.4 5.2 8.4 5.2-8.4 5.2 8.4 5.2-8.4L94 6.2h3.5",
    fill: "none",
    stroke: "#00a2b6",
    strokeWidth: 2
  }));
}